import { ToastBody as _ToastBody, ToastBodyProps as _ToastBodyProps } from "reactstrap";

    export const ToastBody = _ToastBody;
    export type ToastBodyProps = _ToastBodyProps;
    